export default "__VITE_ASSET__BL5LOL8t__"